import { InjectionToken } from '@angular/core';

export const StytchPublicToken = new InjectionToken<string>(
  'StytchPublicToken'
);
